export enum HorizontalAlignmentEnum {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum VerticalAlignmentEnum {
  Top = 'top',
  Center = 'center',
  Bottom = 'bottom',
}

export enum BackgroundStyleEnum {
  White = 'White',
  Black = 'Black',
  LightGray = 'Light Gray',
  TextureLight = 'Texture Light',
  TextureDark = 'Texture Dark',
  ButcherPaper = 'Butcher Paper',
  DarkGray = 'Dark Gray',
}

export const ButtonStyleEnum = Object.freeze({
  Primary: 'Primary',
  Secondary: 'Secondary',
  Tertiary: 'Tertiary',
  Text: 'Text & Icon',
});

export const ButtonIconEnum = Object.freeze({
  Skewer: 'Skewer',
  Knife: 'Knife',
});
